const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://api.aicarma.com";
const LOGO_API_URL = import.meta.env.VITE_LOGO_API_URL || "https://api.logo.dev";
 
export const API_ENDPOINTS = {
  /** Current user's account (role, owner_id for brand/data scoping). Requires Bearer API token + user_id query. */
  account: `${API_BASE_URL}/v1/account/`,
  brandRegister: `${API_BASE_URL}/v1/get-brand/`,
  competitors: `${API_BASE_URL}/v3/competitors/`,
  fillupCompetitor: `${API_BASE_URL}/fillupcompetitor/`,
  syncScores: `${API_BASE_URL}/sync_scores/`,
  scores: `${API_BASE_URL}/scores/`,
  extendScores: `${API_BASE_URL}/extend_scores/`,
  createInvitation: `${API_BASE_URL}/v1/account/invitations`,
  invitations: `${API_BASE_URL}/v1/invitations`,
  logoSearch: (query: string) =>
    `${LOGO_API_URL}/search?q=${encodeURIComponent(query)}`,
  logoDescribe: (domain: string) => `${LOGO_API_URL}/describe/${domain}`,
  agencyManagedAccounts: `${API_BASE_URL}/v1/agency/managed-accounts`,
  agencyAccountContents: (accountId: string) =>
    `${API_BASE_URL}/v1/account/accounts/${encodeURIComponent(accountId)}/contents`,
  agencyCreate: `${API_BASE_URL}/v1/agency/create`,
  agencyInviteClient: `${API_BASE_URL}/v1/agency/invite-client`,
  agencyAcceptInvite: `${API_BASE_URL}/v1/agency/accept-invite`,
  agencyCreateClient: `${API_BASE_URL}/v1/agency/clients/create`,
  brandMetadata: `${API_BASE_URL}/v1/brand-metadata/`,
} as const;
